import React from 'react';
import { css } from 'aphrodite';
import styles from './past-bookings-styles';
import ContentCard from '../common/content-card/content-card';
import BookingSummary from '../booking-summary/booking-summary';

const PastBookingsView = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Past bookings'}>
      {(props.pastBookings.journeyReports || []).map(booking => (
        <BookingSummary
          key={booking.id}
          booking={booking}
        />
      ))}
    </ContentCard>
  </div>
);

export default PastBookingsView;



// WEBPACK FOOTER //
// ./src/components/past-bookings/past-bookings-view.js